import { Card, CardContent } from "@/components/ui/card";

export const StatCard = ({ icon: Icon, label, value, testId }) => (
  <Card className="rounded-xl">
    <CardContent className="space-y-1 p-5">
      <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        <Icon className="h-3.5 w-3.5" /> {label}
      </p>
      <p data-testid={testId} className="font-display text-3xl">{value}</p>
    </CardContent>
  </Card>
);
